export const subscriptionRecoverySelectors = {
  form: "#subscription-recovery-form",
  cardNumber: "#recovery-card-number-element",
  cardExpiry: "#recovery-card-expiry-element",
  cardCvc: "#recovery-card-cvc-element",
  errors: "#subscription-recovery-errors",
  submitButton: "#subscription_recovery_button",
  cardholderName: "#cardholder_name",
  postalCode: "#postal_code",
} as const;

export type SubscriptionRecoverySelectorName = keyof typeof subscriptionRecoverySelectors;

export type SubscriptionRecoveryProbeState = {
  readonly formPresent: boolean;
  readonly missingTargets: readonly SubscriptionRecoverySelectorName[];
  readonly currentRuntime: "legacy-asset-builder";
  readonly nextRuntime: "esbuild-module";
};

const requiredTargets: readonly SubscriptionRecoverySelectorName[] = [
  "form",
  "cardNumber",
  "cardExpiry",
  "cardCvc",
  "errors",
  "submitButton",
  "cardholderName",
  "postalCode",
];

export function subscriptionRecoveryProbeState(root: ParentNode = document): SubscriptionRecoveryProbeState {
  const missingTargets = requiredTargets.filter((target) => {
    return !root.querySelector(subscriptionRecoverySelectors[target]);
  });

  return {
    formPresent: !missingTargets.includes("form"),
    missingTargets,
    currentRuntime: "legacy-asset-builder",
    nextRuntime: "esbuild-module",
  };
}

export function markSubscriptionRecoveryProbeReady(documentRef: Document = document): SubscriptionRecoveryProbeState {
  const state = subscriptionRecoveryProbeState(documentRef);
  const form = documentRef.querySelector<HTMLFormElement>(subscriptionRecoverySelectors.form);

  documentRef.documentElement.dataset.subscriptionRecoveryProbe =
    state.formPresent && state.missingTargets.length === 0 ? "ready" : "absent";

  if (form) {
    form.dataset.esbuildSubscriptionRecoveryProbe =
      state.missingTargets.length === 0 ? "ready" : "missing-targets";
  }

  return state;
}

export function installSubscriptionRecoveryProbe(documentRef: Document = document): void {
  const markReady = (): void => {
    markSubscriptionRecoveryProbeReady(documentRef);
  };

  if (documentRef.readyState === "loading") {
    documentRef.addEventListener("DOMContentLoaded", markReady, { once: true });
  } else {
    markReady();
  }

  documentRef.addEventListener("turbo:load", markReady);
}
